export const EmailRegexp = /\S+@\S+\.\S+/g;
export const PasswordRegexp = /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/g;
export const PriceRegexp = /^[\d]*(\.[\d]{0,2})?$/g;
export const IntRegexp = /^-?\d+$/g;
export const RtmpUrlRegexp = /^rtmps?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)/g;
export const HttpUrlRegexp = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.?[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;